import React, {useEffect, useRef, useState} from "react";
import {Tooltip} from "react-tooltip";

const Tooltips = ({
                    text = "",
                    children,
                    style = null,
                    delayShow = 500,
                    tooltipId,
                    place = "bottom",
                    html = null,
                    className = "tooltip_icon",
                    content = "",
                    portal = false
                  }) => {
  const [tooltipText, setTooltipText] = useState(text);
  const containerRef = useRef(null);
  const portalRoot = portal ? document.body : null;

  useEffect(() => {
    setTooltipText(text)
  }, [text])

  if (!text && !content && !html) return null

  return (
    <>
      <div
        ref={containerRef}
        data-tooltip-id={tooltipId}
        className={className}
      >
        {children}
      </div>
      <Tooltip
        // isOpen={true}
        portalRoot={portalRoot}
        positionStrategy={portalRoot ? "fixed" : "absolute"}
        id={tooltipId}
        border={"1px solid #C9C9C9"}
        variant={'light'}
        content={content || html || tooltipText}
        html={html}
        place={place}
        style={style}
        effect='solid'
        className={"simple_tooltip_text"}
        delayShow={delayShow}
        // closeOnEsc={true}
        data-border-class={"border"}
        eventOff={"mouseleave mouseout scroll mousewheel blur"}
      >{content ? content : text}</Tooltip>

    </>
  )
}

export default Tooltips;